import type {
  DeleteAccountResponse,
  DeleteAccountVerificationRequestResponse,
  GetUserProfileResponse,
} from '@/types/user'
import type { Options } from 'ky'
import type {
  ChangePasswordFormFieldSchema,
  DeleteAccountSchema,
  UpdateProfileSchema,
  VerifyEmailAccountFormFieldSchema,
} from '@/schemas/user'
import { httpClient } from '@/utils/http'

export const userService = {
  getProfile: (options?: Options) =>
    httpClient.get('profiles', options).json<GetUserProfileResponse>(),
  patchProfile: (payload: UpdateProfileSchema, options?: Options) =>
    httpClient
      .patch('profiles', {
        ...options,
        json: payload,
      })
      .json<GetUserProfileResponse>(),
  deleteAccountRequestVerification: (options?: Options) =>
    httpClient
      .post('verifications/generate/delete_account', options)
      .json<DeleteAccountVerificationRequestResponse>(),
  deleteAccount: (payload: DeleteAccountSchema, options?: Options) =>
    httpClient
      .delete('profiles', { ...options, json: payload })
      .json<DeleteAccountResponse>(),
  sendVerificationEmail: () =>
    httpClient.post('verifications/generate/verify_email').json(),
  verifyEmail: (payload: VerifyEmailAccountFormFieldSchema) =>
    httpClient.post('verifications/verified', { json: payload }).json(),
  changePassword: (payload: ChangePasswordFormFieldSchema) =>
    httpClient
      .post('passwords', { json: { organization_admin: payload } })
      .json(),
}
